import type {
  ShareAnalysisCreateRequest,
  ShareAnalysisCreateResponse,
  ShareAnalysisSnapshot,
} from '@eloquor/api-contract';
import { apiFetch } from './client';

export async function createShareAnalysis(
  req: ShareAnalysisCreateRequest
): Promise<ShareAnalysisCreateResponse> {
  return apiFetch<ShareAnalysisCreateResponse>('/analyses', { method: 'POST', json: req });
}

export async function readShareAnalysis(id: string): Promise<ShareAnalysisSnapshot> {
  return apiFetch<ShareAnalysisSnapshot>(`/analyses/${encodeURIComponent(id)}`);
}
